import React from 'react'
import PasswordStrengthBar from 'react-password-strength-bar'
import {createUseStyles} from 'react-jss'

const useStyles = createUseStyles({
  root: {
    marginBottom: '.5em',
    '& div': {
      width: '85%'
    },
    '& p': {
      marginTop: '-12px !important'
    }
  },
})

const PasswordStrengthMeter = (props) => {
  const classes = useStyles()

  return (
    <PasswordStrengthBar 
      className={classes.root}
      password={props.password} 
      minLength="8"
      minScore="3"
      scoreWords={['too short', 'weak', 'okay', 'good', 'strong']}
    />
  )
}

export default PasswordStrengthMeter